import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomRouter, View } from '@lib/core';
import { BasketStore } from '@lib/shared/basket-service';
import {SupplierBasket} from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';

@Component({
    selector: 'basket-header',
    templateUrl: './basket-header.component.html',
    standalone: false
})
export class BasketHeaderComponent implements OnInit {
    private readonly basketStore = inject(BasketStore);
    private readonly router = inject(CustomRouter);

    supplierBaskets$!: Observable<SupplierBasket[]>;

    ngOnInit(): void {
        this.streamSupplier();
    }

    streamSupplier(): void {
        this.supplierBaskets$ = this.basketStore.supplierBaskets;
    }

    open(): void {
        if (this.isOnBasketPage()) {
            this.basketStore.resetStepper();
            return;
        }
        this.router.navigate([View.CLIENT, 'basket']);
    }

    private isOnBasketPage(): boolean {
        return this.router.url.split('?')[0].endsWith('/basket');
    }
}
